export function setSelectionRangeAsync(input, range, timeout = 0) {
    setTimeout(() => input.setSelectionRange(...range), timeout);
}
